// TODO: This is originally a copy of articlesearch-ui/src/app/utils/BasketUtil.ts,
//   which has already diverged from the original in the meantime! --> Align both
//   versions and migrate all places to using THIS version of the two diverged copies!

import { calculatePiecesFromWeight } from "betty-ordercapture-amountchooser";
import type { BettyBundleStore } from "../types/EvaluateArticleNew";

export function calculateAmountForBasket<FlexibleWeightPerPieceDefinition extends { value: number | undefined }>(
    amount: number,
    isWeightedArticle: boolean,
    weightPerPiece: FlexibleWeightPerPieceDefinition | null | undefined
) {
    if (isWeightedArticle && weightPerPiece && weightPerPiece?.value) {
        return Number((amount * weightPerPiece.value).toFixed(2));
    }
    return amount;
}

export function calculateAmountToDisplay<FlexibleWeightPerPieceDefinition extends { value: number | undefined }>(
    amount: number | undefined | null,
    isWeightedArticle: boolean | null | undefined,
    weightPerPiece: FlexibleWeightPerPieceDefinition | null | undefined
): number | null | undefined {
    if (amount && isWeightedArticle && weightPerPiece && weightPerPiece?.value) {
        return calculatePiecesFromWeight(amount, weightPerPiece.value);
    }
    return amount;
}

export function canNotBeAddedToBasket(
    isDeprecated: boolean,
    isNonExistentBundle: boolean,
    isCartEnabled: boolean,
    store: BettyBundleStore | null
): boolean {
    return (
        (!store?.customerBuyable && !store?.employeeBuyable) || isDeprecated || !isCartEnabled || isNonExistentBundle
    );
}
